export default __webpack_public_path__ + "images/40a87912f4a596544ecb13e46cde23b8.png";